<template>

  <div class="element-box">
    <div class="table-responsive">
      <table class="table table-striped table-lightborder table-striped">

        <tbody>
          <tr v-for="chunk in chunkedItems">
            <td v-for="image in chunk">
              <clazy-load :src="getImage(image)" class="">
                <img :src="getImage(image)" @click="zoomImage(image)">
                <div class="preloader" slot="placeholder">
                  Loading image
                </div>
              </clazy-load>
              {{image.item_identifier}}_{{image.sequence}}
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>

<script>
import { chunk } from 'lodash'

export default {
  props: ['images'],
  methods: {
    getImage: function (image) {
      if (image) {
        return image.host + image.raw_thumb_location
      } else {
        return 'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
      }
    },
    zoomImage: function (image) {
      var context = {
        content: image,
        contentType: 'image',
        show: true
      }
      this.$store.dispatch('updateModal', context)
    }
  },
  computed: {
    chunkedItems () {
      return chunk(this.images, 5)
    }
  }
}
</script>

<style scoped>
.property-side-features .feature {
  padding: 5px 10px;
}
.hidden {
  display: none;
}
td {
  white-space: nowrap;
}
td.wrap {
  white-space: normal;
}
td.center {
  text-align: center;
}
.clickable {
  color: blue;
  cursor: pointer;
}
.element-box {
  display: flex;
  flex: 1;
  overflow-x: scroll;
  overflow-y: scroll;
}
.product-flags {
  margin-right: 5px;
}
.Yes-Circle::before {
  content: "\f058";
  color: #75da62 !important;
}

.No-Circle::before {
  content: "\f057";
  color: #ed1c24 !important;
}

.Skipped-Circle::before {
  content: "\f05e";
}

.Skipped::before {
  content: "\f05e";
}

.Yes-text {
  color: #75da62 !important;
  font-weight: 500;
}
.Yes::before {
  content: "\f00c";
  color: #75da62 !important;
}
.No-text {
  color: #ed1c24 !important;
  font-weight: 500;
}
.No::before {
  content: "\f00d";
  color: #ed1c24 !important;
}
.NA::before {
  content: "\f068";
}
.Pending-text {
  color: #ffa000 !important;
  font-weight: 500;
}
.Pending::before {
  content: "\f12a";
  color: #ffa000 !important;
}
.Styling::before {
  content: "\f0d1";
  color: #000 !important;
}
.Comment::before {
  content: "\f075";
  color: #000 !important;
}
.ForceComplete::before {
  content: "\f560";
  color: #000 !important;
}
.profile-tile .pt-avatar-w {
  border-radius: 0px;
}
.profile-tile .profile-tile-box {
  padding: 0.5rem;
  width: 80px;
}
.profile-tile .profile-tile-meta ul {
  font-size: 13px;
}
.profile-tile .profile-tile-meta {
  padding-left: 10px;
}
.profile-tile .profile-tile-meta ul strong {
  margin-left: 0px;
}
.profile-tile {
  border-bottom: 0px;
  padding-bottom: 0rem;
  margin-bottom: 0rem;
}
.profile-tile .profile-tile-meta ul .clickable-link strong {
  color: #047bf8 !important;
  cursor: pointer;
}
</style>
